// Types REDUX
// USER
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const USER_LOADED = 'USER_LOADED'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGOUT = 'LOGOUT'
export const SET_LOADING_AUTH = 'SET_LOADING_AUTH'
// CATEGORIES
export const GET_ALL_CATEGORIES = 'GET_ALL_CATEGORIES';
// PRODUCTS
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const SET_LOADING_PRODUCTS = 'SET_LOADING_PRODUCTS'
export const ORDER_PRODUCTS = 'ORDER_PRODUCTS';
export const FILTER_BY_CATEGORY = 'FILTER_BY_CATEGORY';
export const SEARCH_BY_NAME = 'SEARCH_BY_NAME';
export const RESTART_FILTERS = 'RESTART_FILTERS';
export const RESTART_PRODUCTS = 'RESTART_PRODUCTS';
export const SET_OPTIONS = 'SET_OPTIONS';
export const PAGINATE_COUNTRIES = 'PAGINATE_COUNTRIES';
export const SET_PAGE = 'SET_PAGE';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const SET_PRODUCT_TO_EDIT = 'SET_PRODUCT_TO_EDIT';

// CARRITO
export const ADD_TO_CART = 'ADD_TO_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const REMOVE_ALL_FROM_CART = 'REMOVE_ALL_FROM_CART';
export const REMOVE_ONE_FROM_CART = 'REMOVE_ONE_FROM_CART';

// ORDERS
export const GET_ORDERS_BY_USER = "GET_ORDERS_BY_USER";
export const SET_LOADING_ORDERS = "SET_LOADING_ORDERS";
export const CREATE_ORDER = "CREATE_ORDER";
export const CLEAR_ORDER = "CLEAR_ORDER";
export const DELETE_ORDER = "DELETE_ORDER";

// ADMIN
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_SALES = "GET_ALL_SALES";
export const SET_LOADING_ADMIN = "SET_LOADING_ADMIN";
export const BLOCK_USER = "BLOCK_USER";
export const UNLOCK_USER = "UNLOCK_USER";
export const COMPLETE_ORDER = "COMPLETE_ORDER";